import { Box, styled } from "@mui/material";

export const ShopListItemStyles = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 10px",
    ".MuiBox-root": {
        display: "flex",
        alignItems: "center",
    },
}));

export const DialogListBox = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    maxHeight: "300px",
    overflowY: "auto",
    borderTop: `1px solid ${theme.palette.border.main}`,
}));

export const StyledDialogListBox = styled(DialogListBox)(({ theme }) => ({
    maxHeight: "500px",
    overflowY: "auto",
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.border.main}`,
}));
